import { render } from "./MenuBottom.vue?vue&type=template&id=3856f05c&scoped=true"
import script from "./MenuBottom.vue?vue&type=script&lang=js"
export * from "./MenuBottom.vue?vue&type=script&lang=js"

import "./MenuBottom.vue?vue&type=style&index=0&id=3856f05c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3856f05c"]])

export default __exports__